<template>
  <div>
    <b-row class="mt-5">
      <b-col cols="12">
        <h4>Documenten</h4>
        <hr>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="6">
        <ul class="list-group mb-5" >
          <li class="list-group-item d-flex justify-content-between">
            <div class="w-50 flex-grow-0"><strong>Bestandsnaam</strong></div>
            <div class="w-50 flex-grow-0"><strong>Label</strong></div>
          </li>

          <li v-for="item in files" :key="item.id" class="list-group-item d-flex justify-content-between">
            <div class="w-50 flex-grow-0">
              <a :href="item.url" class="flex-grow-1" target="_blank">{{ item.name }}</a>
            </div>

            <div class="w-25 flex-grow-0">
               <strong>{{formatLabel(item.label)}}</strong>
            </div>

            <div class="w-25 mr-0 flex-grow-0 d-flex justify-content-end">
              <b-button class="btn-sm btn-danger hoverable" @click="openRemoveModal(item)">
                <i class="fa fa-trash mr-2"></i> Verwijderen
              </b-button>
            </div>
          </li>
        </ul>
      </b-col>
    </b-row>

    <b-modal ref="remove-file" id="remove-file" title="Bestand verwijderen">
      <p class="my-4">Weet je zeker dat je <strong>"{{deletable.name}}"</strong> wilt verwijderen? Deze actie is
        onomkeerbaar.</p>
      <template v-slot:modal-footer>
        <b-button @click="hideModal">Nee</b-button>
        <b-button variant="danger" @click="deleteFile">Ja, verwijder</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>

import {deleteItem, updateData} from "@/api";

export default {
  props: ['files'],
  data() {
    return {
      deletable: {},
    }
  },
  methods: {
    deleteFile() {
      deleteItem(`portal-users/${this.$route.params.id}/documents/${this.deletable.id}`).then(({data}) => {
        this.$refs['remove-file'].hide();
        this.$emit('deletedFile', data.deletedId)

      });
    },
    openRemoveModal(document) {
      this.deletable = document;

      this.$refs['remove-file'].show();
    },
    hideModal() {
      this.$refs['remove-file'].hide();
    },
    formatLabel(label) {
      if (label === 'general') return 'Algemeen';
      return label;
    }
  }
}
</script>

<style>
.card-img-top {
  max-height: 150px;
  min-height: 150px;
  object-fit: cover;
}
</style>
